import React from 'react';
import Typography from '@hpstellar/core/Typography';

import withPageComponents from '../../page/components/with-page-components';

import '../css/return-exchange-info.less';

const EMPTY_OBJECT = {};

const ReturnsAndExchange = ({ title='Return and exchange information', returnMsg, product=EMPTY_OBJECT }) => {
    const { prdClass='' } = product;
    let message = returnMsg || "HP.com will accept returns or exchanges for this product up to 30 days after delivery.";

	if(["vgc","pgc"].includes(prdClass.toLowerCase())) {
		message = "This product cannot be returned except where required by law."
	}

	return (
        <div className='return-info'>
            <Typography
                tag="h3"
                variant="headingTitleSmall"
            >
                {title}
            </Typography>
            <Typography
                tag="div"
                variant="bodyRegular"
            >
                {message}
            </Typography>
        </div>
    )
}

export default withPageComponents(ReturnsAndExchange, { components: ['product'] });